import type {
  DutyGenerationStatsQuery,
  DutyGenerationStatsResponse,
  DutyRequestStatsQuery,
  DutyRequestStatsResponse,
  UserTrendStatsQuery,
  UserTrendStatsResponse,
} from "dutyon-server/types";
import { httpClient } from "./httpClient";

export const getDutyGenerationStats = async (
  query?: DutyGenerationStatsQuery,
): Promise<DutyGenerationStatsResponse> => {
  const searchParams = new URLSearchParams();
  if (query?.startDate) searchParams.set("startDate", query.startDate);
  if (query?.endDate) searchParams.set("endDate", query.endDate);
  if (query?.companyId) searchParams.set("companyId", query.companyId);

  const queryString = searchParams.toString();
  const url = `/statistics/duty-generation${queryString ? `?${queryString}` : ""}`;
  const response = await httpClient.get<DutyGenerationStatsResponse>(url);
  if (!response.data || response.data.source !== "database" || response.data.isMockData !== false)
    throw new Error("내부 저장 기록 기반 통계가 아직 준비되지 않았습니다.");
  return response.data;
};

export const getDutyRequestStats = async (
  query?: DutyRequestStatsQuery,
): Promise<DutyRequestStatsResponse> => {
  const searchParams = new URLSearchParams();
  if (query?.startDate) searchParams.set("startDate", query.startDate);
  if (query?.endDate) searchParams.set("endDate", query.endDate);
  if (query?.companyId) searchParams.set("companyId", query.companyId);

  const queryString = searchParams.toString();
  const url = `/statistics/duty-requests${queryString ? `?${queryString}` : ""}`;
  const response = await httpClient.get<DutyRequestStatsResponse>(url);
  return response.data;
};

export const getUserTrendStats = async (
  query?: UserTrendStatsQuery,
): Promise<UserTrendStatsResponse> => {
  const searchParams = new URLSearchParams();
  if (query?.startDate) searchParams.set("startDate", query.startDate);
  if (query?.endDate) searchParams.set("endDate", query.endDate);
  if (query?.companyId) searchParams.set("companyId", query.companyId);

  const queryString = searchParams.toString();
  const url = `/statistics/user-trends${queryString ? `?${queryString}` : ""}`;
  const response = await httpClient.get<UserTrendStatsResponse>(url);
  return response.data;
};
